import { appConfig } from '../../../../config'
import { FeatureFlags } from './types'

export const getFeatureFlags = async ({ accessToken }: { accessToken: string }): Promise<FeatureFlags> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/featureFlag`, {
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  return res.json()
}
